export const APP_ROUTES = {
  DEVICE_DETAILS: '/device-details/',
  HOME: '/',
  CRITICAL_DATA: '/critical-data',
  DYNAMIC_DATA_LOG: '/data-log',
  MS_PROVIDERS: '/ms-providers',
  USERS: '/users',
  GROUPS: '/groups',
  UNASSIGNED_DEVICES: '/groups/unassigned',
  GROUP_DETAILS: '/groups/:groupId',
  ORGANIZATIONS: '/organizations',
  ORGANIZATION_SETTINGS: '/organization-settings',
  POWER_LINES: '/power-lines',
  POWER_LINE_DETAILS: '/power-lines/:powerLineId',
  NOTIFICATION_CENTER: '/notification-center',
  ACCOUNT_SECURITY: '/account-security',
  AUTH: '/auth',
  /** Public Google OAuth popup redirect (must match Google Cloud redirect URI). */
  GOOGLE_CALLBACK: '/auth/google/callback',
  FORGOT_PASSWORD: '/forgot-password',
  RESET_PASSWORD: '/reset-password/:token',
  REQUEST_UNLOCK: '/request-unlock',
  LOCKED_ACCOUNTS: '/locked-accounts',
  UNLOCK_REQUESTS: '/unlock-requests',
  TERMS_OF_SERVICE: '/terms-of-service',
  PRIVACY_POLICY: '/privacy-policy',
};

export type GroupDetailsTab = 'devices' | 'users';

export const getGroupDetailsUrl = (
  groupId: string | number,
  tab: GroupDetailsTab = 'devices'
): string => `/groups/${groupId}?tab=${tab}`;

export const UNASSIGNED_ORG_PARAM = 'org';
/** Frontend-only URL value. Maps to filterBy[NoOrganization]=true, never sent as OrganizationID. */
export const UNASSIGNED_NO_ORG_PARAM_VALUE = 'none';

export const isUnassignedNoOrganizationParam = (
  value?: string | number | null
): boolean => String(value ?? '').toLowerCase() === UNASSIGNED_NO_ORG_PARAM_VALUE;

export const isPositiveOrganizationId = (
  value?: string | number | null
): boolean => /^[1-9]\d*$/.test(String(value ?? ''));

export const getUnassignedDevicesUrl = (
  organizationId?: string | number | null
): string => {
  if (isUnassignedNoOrganizationParam(organizationId)) {
    const params = new URLSearchParams({
      [UNASSIGNED_ORG_PARAM]: UNASSIGNED_NO_ORG_PARAM_VALUE,
    });
    return `${APP_ROUTES.UNASSIGNED_DEVICES}?${params.toString()}`;
  }
  if (!isPositiveOrganizationId(organizationId)) {
    return APP_ROUTES.UNASSIGNED_DEVICES;
  }
  const params = new URLSearchParams({ [UNASSIGNED_ORG_PARAM]: String(organizationId) });
  return `${APP_ROUTES.UNASSIGNED_DEVICES}?${params.toString()}`;
};
